var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHandout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 16,
    width: 16,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "handout") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "square",
    strokeWidth: 2,
    fill: "none",
    stroke: "#000000",
    strokeLinejoin: "miter",
    className: "nc-icon-wrapper",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 9.5,
    r: 2.5,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 3.5,
    r: 2.5,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    "data-cap": "butt",
    d: "M13.476,16H19c2.817,0,3,2,3,2 l-11.765,4.525c-0.787,0.303-1.665,0.26-2.419-0.117L1,19v-7h1c1.105,0,3.906,0.438,5,2l0,0h3c2.209,0,4,1.791,4,4l0,0H7",
    strokeLinecap: "butt"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandout);
export default __webpack_public_path__ + "static/media/handout.d51b758397f03ff88940ba526e1dc535.svg";
export { ForwardRef as ReactComponent };